import React from 'react';
import { useDemoStore } from '../../../../store/demoFlowStore';
import { ArrowLeft } from 'lucide-react';

export const OrdersPage = () => {
  const { orders, updateOrder } = useDemoStore();

  const statuses = ['Draft', 'Request Owner', 'Approvals', 'Sent to store', 'Dispatched', 'Received'];

  return (
    <div className="p-6 md:p-10 w-full">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="page-title mb-1">Orders</h1>
          <p className="text-[13px] text-gray-500">Track and manage client orders through production.</p>
        </div>
      </div>

      <div className="card overflow-hidden">
        <div className="overflow-x-auto">
          <table>
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Customer</th>
                <th>Items</th>
                <th>Total Amount</th>
                <th>Date</th>
                <th>Status / Actions</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((ord) => (
                <tr key={ord._id} className="group">
                  <td className="font-semibold text-black">{ord.customId}</td>
                  <td>{ord.customer}</td>
                  <td className="text-gray-500">
                    {ord.items?.length || 1} items
                  </td>
                  <td className="font-semibold">{ord.amount}</td>
                  <td className="text-gray-400 text-[12px]">{ord.date}</td>
                  <td>
                    <select
                      className="text-[11px] font-semibold text-black bg-gray-50 hover:bg-gray-100 px-3 py-1.5 rounded-lg border-0 cursor-pointer outline-none transition-colors"
                      value={ord.status}
                      onChange={(e) => updateOrder(ord._id, { status: e.target.value })}
                    >
                      {statuses.map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {orders.length === 0 && (
          <div className="p-12 text-center text-gray-400 text-[13px]">
            No orders found.
          </div>
        )}
      </div>
    </div>
  );
};




